import { useContext } from 'react'
import { ProjectContext, UserContext } from '../../contexts'
import PageContent from '../../ui/PageContent'
import { NavigationTabs } from '../../ui/Tabs'
import { Outlet, useNavigate } from 'react-router'
import { InfoTable } from '../../ui/InfoTable'
import { Button } from '../../ui'
import { TrashIcon } from '../../ui/icons'
import api from '../../api'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-hot-toast/headless'

export default function UserDetail() {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const [project] = useContext(ProjectContext)
    const [{ id, external_id, email, phone, timezone, full_name }] = useContext(UserContext)

    const deleteUser = async () => {
        if (confirm(t('delete_user_confirmation'))) {
            try {
                await api.users.delete(project.id, id)
                await navigate(`/projects/${project.id}/users`)
            } catch {
                toast.error(t('delete_user_error'))
            }
        }
    }

    return (
        <PageContent
            title={full_name ?? (email ?? t('no_email'))}
            desc={
                <InfoTable rows={{
                    [t('id')]: external_id,
                    [t('email')]: email,
                    [t('phone')]: phone,
                    [t('timezone')]: timezone,
                }} direction="horizontal" />
            }
            actions={
                <Button icon={<TrashIcon />}
                    onClick={deleteUser}
                    variant="destructive_secondary">{t('delete_user')}</Button>
            }
        >
            <NavigationTabs tabs={[
                {
                    key: 'details',
                    to: '',
                    end: true,
                    children: t('details'),
                },
                {
                    key: 'events',
                    to: 'events',
                    children: t('events'),
                },
                {
                    key: 'subscriptions',
                    to: 'subscriptions',
                    children: t('subscriptions'),
                },
                {
                    key: 'journeys',
                    to: 'journeys',
                    children: t('journeys'),
                },
                {
                    key: 'notifications',
                    to: 'notifications',
                    children: t('notifications'),
                },
            ]} />
            <Outlet />
        </PageContent>
    )
}
